(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["florist-faqs"]) return;
  try {
    
const accordion = document.getElementsByClassName('accordion-item');
for (i=0; i<accordion.length; i++) {
  accordion[i].addEventListener('click', function () {
    this.classList.toggle('active')
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["florist-multipart-signup"]) return;
  try {
    
  let tabsContentNavs = document.querySelectorAll('.florist-signup-section-tab-nav');
  var florist_type_selected = "type_1";
  const florist_type_1_button = document.querySelector('#florist_type_1');
  const florist_type_2_button = document.querySelector('#florist_type_2');
  const num_bouquets_input = document.getElementById('num_bouquets');
  const num_days_input = document.getElementById('num_days');
  const ave_cost_input = document.getElementById('ave_cost');
  const florist_profit_result = document.getElementById('florist_profit');
  const florist_selected_type = document.getElementById('florist_selected_type');
  
  tabsContentNavs.forEach(tabsContentNav => {
    tabsContentNav.addEventListener('click', function(event) {
      // Prevent keeping the active class on clicked nav button/trigger
      event.target.classList.remove('active');
    });
  });
  
  florist_type_1_button.addEventListener('click', function(event) {
    florist_type_selected = "type_1";
    // Reset selected values upon navigating to other parts
    num_bouquets_input.value = '';
    num_days_input.value = '';
    ave_cost_input.value = '';
    florist_profit_result.textContent = '-';
    florist_selected_type.textContent = "I am independent florist who " + florist_type1_label;
  });
  
  florist_type_2_button.addEventListener('click', function(event) {
    florist_type_selected = "type_2";
    // Reset selected values upon navigating to other parts
    num_bouquets_input.value = '';
    num_days_input.value = '';
    ave_cost_input.value = '';
    florist_profit_result.textContent = '-';
    florist_selected_type.textContent = "I am independent florist who " + florist_type2_label;
  });

  let commissionCalcInputs = document.querySelectorAll('.commission-calc_input');
  commissionCalcInputs.forEach(commissionCalcInput => {
    commissionCalcInput.addEventListener('input', function(event) {
      // Only run if all inputs are entered
      if(num_bouquets_input.value && num_days_input.value && ave_cost_input.value){
        var daily_ave = 0;
        var product_budget = 0;
        var commission = 0;

        daily_ave = Math.floor(num_bouquets_input.value / num_days_input.value);
      
        if(florist_type_selected == "type_1"){
          // product budget + commission
          if(daily_ave >= 1 && daily_ave <= 5){
            product_budget = 0.30;
            commission = 0.20;
          }
          else if(daily_ave >= 6 && daily_ave <= 10){
            product_budget = 0.25;
            commission = 0.20;
          }
          else {
            product_budget = 0.10;
            commission = 0.15;
          }
          
          florist_profit_result.textContent = `$${(((ave_cost_input.value * product_budget) + ((ave_cost_input.value - 5) * commission)) * num_bouquets_input.value).toFixed(2)}`;
        }
        if(florist_type_selected == "type_2"){
          // commission only
          if(daily_ave >= 1 && daily_ave <= 4){
            commission = 0.20;
          }
          else if(daily_ave >= 5 && daily_ave <= 7){
            commission = 0.175;
          }
          else {
            commission = 0.15;
          }
          
          florist_profit_result.textContent = `$${(((ave_cost_input.value - 5) * commission) * num_bouquets_input.value).toFixed(2)}`;
        }
      }
      else {
        florist_profit_result.textContent = '-';
      }
      
    });
  });
  
  const floristSignUpFormToggle = document.getElementById('florist-signup-cta');
  const floristSignUpFormDiv = document.getElementById('florist-signup-form');
  floristSignUpFormToggle.addEventListener('click', function () {
    floristSignUpFormDiv.classList.toggle('active');
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s_timeline"] && !Shopify.designMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("s-timeline__img--bounce-in"),t.contents[e].classList.add("s-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-s-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-faqs"] && !Shopify.designMode) return;
  try {
    
const accordion = document.getElementsByClassName('accordion-item');
for (i=0; i<accordion.length; i++) {
  accordion[i].addEventListener('click', function () {
    this.classList.toggle('active')
  })
}

  } catch(e) { console.error(e); }
})();
})();
